import api from "apis/customerInsights";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE, HTTP_PUT } from "tools/webservice";

export const addCustomerInsightNotification = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addNotification(),
  payload,
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const deleteCustomerInsightNotification = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteNotification(id),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const updateCustomerInsightNotification = (id, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.updateNotification(id),
  payload,
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const getCustomerInsightNotification = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getNotification(id),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const searchCustomerInsightNotifications = (searchTerm, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.searchWithText(searchTerm),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const getCustomerInsightNotificationsByAccount = (customerNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getNotificationsByAccount(customerNumber),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const addCustomerInsightNotificationAccount = (id, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addAccountToNotification(id),
  payload,
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const deleteCustomerInsightNotificationAccount = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteAccountFromNotification(id),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});

export const getCustomerInsightNotificationAccounts = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getAccountsForNotification(id),
  successCallback,
  errorCallback: e => errorCallback(e.response),
  mountedRef,
});